<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center">
          <button @click="back" class="btn btn-outline-secondary btn-icon-text py-2 px-3 mr-3">
            <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
          </button>
          <div>
            <h2 class="text-white font-weight-bold mb-1">{{ $t('makerForm.editTitle') }}</h2>
            <p class="text-muted small mb-0">{{ makerStore.name || $t('makerForm.editSub') }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Form Card -->
    <div class="col-12 grid-margin">
      <div class="card border border-secondary">
        <div class="card-body">
          <form class="forms-sample" method="post" @submit.prevent="submitForm">
            <div class="form-group row">
              <div class="col-md-6 mb-3">
                <label for="nameInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('makerForm.makerName') }}</label>
                <input
                  id="nameInput"
                  type="text"
                  class="form-control"
                  v-model="makerStore.name"
                  :placeholder="$currentLocale === 'id' ? 'Contoh: Jane Smith' : 'e.g. Jane Smith'"
                  required
                />
              </div>
              <div class="col-md-6 mb-3">
                <label for="dobInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('makerForm.dateOfBirth') }}</label>
                <input
                  id="dobInput"
                  type="date"
                  class="form-control"
                  v-model="makerStore.dob"
                />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-6 mb-3">
                <label for="emailInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('makerForm.emailAddress') }}</label>
                <input
                  id="emailInput"
                  type="email"
                  class="form-control"
                  v-model="makerStore.email"
                  :placeholder="$currentLocale === 'id' ? 'Contoh: jane.smith@perusahaan.com' : 'jane.smith@company.com'"
                  required
                />
              </div>
              <div class="col-md-6 mb-3">
                <label for="phone_numberInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('makerForm.phoneNumber') }}</label>
                <input
                  id="phone_numberInput"
                  type="text"
                  class="form-control"
                  v-model="makerStore.phone_number"
                  placeholder="08123456789"
                />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-6 mb-3">
                <label for="passwordInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('makerForm.updatePassword') }}</label>
                <div class="input-group">
                  <input
                    id="passwordInput"
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control"
                    v-model="makerStore.password"
                    :placeholder="$t('makerForm.leaveBlankPassword')"
                  />
                  <div class="input-group-append">
                    <button
                      type="button"
                      class="btn btn-dark border-secondary text-muted"
                      @click="showPassword = !showPassword"
                    >
                      <i :class="showPassword ? 'mdi mdi-eye-off text-warning' : 'mdi mdi-eye'"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="text-muted small text-uppercase font-weight-bold">{{ $t('makerForm.squad') }}</label>
                <select
                  class="form-control"
                  v-model="makerStore.division_id"
                  required
                >
                  <option :value="null" disabled>{{ $t('makerForm.selectSquad') }}</option>
                  <option v-for="option in squadOptions" :key="option.id" :value="option.id">
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-6 mb-3">
                <label for="positionInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('makerForm.position') }}</label>
                <input
                  id="positionInput"
                  type="text"
                  class="form-control"
                  v-model="makerStore.position"
                  :placeholder="$currentLocale === 'id' ? 'Contoh: Manajer Operasional / Squad Lead' : 'e.g. Operations Manager / Squad Lead'"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="text-muted small text-uppercase font-weight-bold">{{ $t('makerForm.changePhoto') }}</label>
                <div class="d-flex align-items-center">
                  <div class="avatar-circle mr-3" style="width: 52px; height: 52px; background: rgba(139, 92, 246, 0.15); color: #8b5cf6; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 20px; overflow: hidden; border: 1px solid #3f3f46;">
                    <img v-if="previewPhoto" :src="previewPhoto" style="width: 100%; height: 100%; object-fit: cover;" />
                    <img v-else-if="maker && maker.profile_picture" :src="config.STORAGE_URL + maker.profile_picture" style="width: 100%; height: 100%; object-fit: cover;" />
                    <i v-else class="mdi mdi-account-tie"></i>
                  </div>
                  <div class="flex-grow-1">
                    <input
                      type="file"
                      class="form-control"
                      id="customFile"
                      accept="image/*"
                      @change="handleFileChange"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2 mt-4">
              <button type="button" @click="back" class="btn btn-outline-secondary px-4 py-2 mr-2" :disabled="loading">
                {{ $t('common.back') }}
              </button>
              <button type="submit" class="btn btn-primary px-4 py-2 font-weight-bold" :disabled="loading">
                <span class="spinner-border spinner-border-sm mr-1" v-if="loading" role="status"></span>
                <i class="mdi mdi-check-all mr-1" v-else></i>
                {{ $t('common.save') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateMaker, getDetailMaker, getSquad } from "@/services/makerService";
import config from "@/config/config";
import Swal from "sweetalert2";

export default {
  name: "EditMaker",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    showPassword: false,
    makerStore: {
      company_id: null,
      name: "",
      email: "",
      phone_number: "",
      password: "",
      division_id: null,
      profile_picture: null,
      role: "maker",
      position: "",
      dob: "",
    },
    squadOptions: [],
    maker: null,
    previewPhoto: null,
    config,
    loading: false,
  }),
  mounted() {
    this.fetchDetailMaker();
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const response = await getSquad();
        this.squadOptions = response.data || [];
      } catch (err) {
        console.error(err);
      }
    },
    async fetchDetailMaker() {
      try {
        const response = await getDetailMaker(this.id);
        const data = response.data || {};
        this.maker = data;
        this.makerStore.company_id = data.company_id;
        this.makerStore.division_id = data.division_id;
        this.makerStore.name = data.name || "";
        this.makerStore.email = data.email || "";
        this.makerStore.phone_number = data.phone_number || "";
        this.makerStore.password = "";
        this.makerStore.dob = data.dob || "";
        this.makerStore.position = data.position || "";
        if (data.role) {
          this.makerStore.role = data.role;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async submitForm() {
      try {
        this.loading = true;
        const payload = { ...this.makerStore };
        if (!payload.password) {
          delete payload.password;
        }

        await updateMaker(this.id, payload);
        Swal.fire({
          icon: "success",
          title: this.$t('common.success'),
          text: this.$t('makerForm.updatedSuccess'),
          confirmButtonColor: "#3b82f6",
        });

        this.$router.push('/maker');
      } catch (error) {
        const errors = error.response?.data?.errors;
        const errMsg = (errors && typeof errors === 'object')
          ? Object.values(errors).flat()[0]
          : (error.response?.data?.message || error.message || (this.$currentLocale === 'id' ? "Gagal memperbarui data maker" : "Failed to update maker data"));
        Swal.fire({
          icon: "error",
          title: this.$t('common.error'),
          text: errMsg,
          confirmButtonColor: "#3b82f6",
        });
      } finally {
        this.loading = false;
      }
    },
    back() {
      this.$router.go(-1);
    },
    handleFileChange(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        this.makerStore.profile_picture = file;
        this.previewPhoto = URL.createObjectURL(file);
      } else {
        this.makerStore.profile_picture = null;
        this.previewPhoto = null;
      }
    },
  },
};
</script>
